/* eslint-disable */

const isDebug = true;
if (typeof console === 'undefined') {
  // IEはログはを出力しない
  console = {
    log() {
    },
  };
} else {
  if (!isDebug) {
    // Debugモードがfalseの場合デバッグしない
    console.log = function () {
    };
  }
}



// WEBPACK FOOTER //
// ./es6/admin-common-js/config/debug-config.js